import { Card, styled } from '@mui/material'

export type ColorType = 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'

export const CardBorderTop = styled(Card)<{ color?: ColorType }>(() => ({}))
